import { Suspense } from 'react';

import { Text } from '@spotify-internal/encore-web';
import { ErrorBoundary } from '@spotify/confidence-core-react';
import { useIssueSuspense } from '@spotify/plugin-confidence-issues-react';
import { PermissionUtils } from '@spotify/plugin-confidence-permissions-react';

import {
  IssueDetailsControls,
  IssueDetailsOverview,
} from '../IssueDetailsPanel';

type IssueArtifactPreviewProps = {
  issueName: string;
};

const IssueArtifactPreviewContent = ({
  issueName,
}: IssueArtifactPreviewProps) => {
  const { issue } = useIssueSuspense({ name: issueName });
  const canEdit = PermissionUtils.hasRelation(issue, 'can_edit');

  return (
    <IssueDetailsOverview
      issue={issue}
      canEdit={canEdit}
      focusInputRequest={false}
      actions={<IssueDetailsControls canEdit={canEdit} issue={issue} />}
    />
  );
};

export const IssueArtifactPreview = ({
  issueName,
}: IssueArtifactPreviewProps) => (
  <ErrorBoundary
    key={issueName}
    renderFallback={() => (
      <Text as="p" variant="bodySmall">
        This issue couldn&apos;t be loaded.
      </Text>
    )}
  >
    <Suspense
      fallback={
        <Text as="p" variant="bodySmall" semanticColor="textSubdued">
          Loading issue details
        </Text>
      }
    >
      <IssueArtifactPreviewContent issueName={issueName} />
    </Suspense>
  </ErrorBoundary>
);
